import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import {
  MARKETING_ICON,
  MARKETING_ICON_FILLED,
} from "../../../../redo-suite/marketing-cloud";

export type EmailSmsSubRoute =
  | "welcome"
  | "ai-personas"
  | "audience"
  | "deliverability"
  | "campaigns"
  | "segments"
  | "templates/email"
  | "templates/sms"
  | "signups";

export const EmailSMSItems = memo(function MarketingItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const settings = team.settings;

  const emailSmsRoot = routes.emailSmsHref;

  const marketingEnabled = settings.marketing?.enabled;

  const showCampaigns =
    marketingEnabled && settings?.marketing?.campaigns?.enabled;

  const showAiPersonas = marketingEnabled && settings?.marketing?.ai?.enabled;

  // TODO: enable when feature is ready
  const showDeliverabilityReport = false;

  const anyChildSelected = useMatch(`${emailSmsRoot}/*`);

  const primaryHref = marketingEnabled
    ? routes.getEmailSmsSubRoute("audience")
    : routes.getEmailSmsSubRoute("welcome");

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: primaryHref }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={MARKETING_ICON_FILLED}
      friendlyName="Email & SMS"
      id="email-sms"
      UnfilledIcon={MARKETING_ICON}
    >
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getEmailSmsSubRoute("welcome") }}
        friendlyName="Welcome"
        hidden={marketingEnabled}
        id="welcome"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getEmailSmsSubRoute("ai-personas"),
        }}
        friendlyName="AI personas"
        hidden={!showAiPersonas}
        id="ai-personas"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getEmailSmsSubRoute("audience") }}
        friendlyName="Audience"
        id="audience"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getEmailSmsSubRoute("deliverability"),
        }}
        friendlyName="Deliverability"
        hidden={!showDeliverabilityReport}
        id="deliverability"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getEmailSmsSubRoute("campaigns") }}
        friendlyName="Campaigns"
        hidden={!showCampaigns}
        id="campaigns"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getEmailSmsSubRoute("segments") }}
        friendlyName="Segments"
        hidden={!showCampaigns}
        id="segments"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getEmailSmsSubRoute("templates/email"),
        }}
        friendlyName="Email library"
        id="email-templates"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getEmailSmsSubRoute("templates/sms"),
        }}
        friendlyName="SMS templates"
        id="sms-templates"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getEmailSmsSubRoute("signups") }}
        friendlyName="Sign-ups"
        hidden={!marketingEnabled}
        id="signups"
      />
    </RedoSecondaryNavItem>
  );
});
